import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';

const LivePeriodDialog = ({
  open,
  onClose,
  livePeriodForm,
  setLivePeriodForm,
  onSave,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>Configure Live Period</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{mt: 1}}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel>Live Period Type</InputLabel>
              <Select
                value={livePeriodForm.live_period_type}
                onChange={(e) =>
                  setLivePeriodForm({
                    ...livePeriodForm,
                    live_period_type: e.target.value,
                  })
                }
                label='Live Period Type'
              >
                <MenuItem value='forever'>Forever</MenuItem>
                <MenuItem value='duration'>Duration (Days)</MenuItem>
                <MenuItem value='until_date'>Until Date</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {livePeriodForm.live_period_type === 'duration' && (
            <Grid item xs={12}>
              <TextField
                fullWidth
                label='Duration (Days)'
                type='number'
                value={livePeriodForm.live_duration_days || ''}
                onChange={(e) =>
                  setLivePeriodForm({
                    ...livePeriodForm,
                    live_duration_days: parseInt(e.target.value),
                  })
                }
              />
            </Grid>
          )}
          {livePeriodForm.live_period_type === 'until_date' && (
            <Grid item xs={12}>
              <TextField
                fullWidth
                label='Until Date'
                type='datetime-local'
                value={livePeriodForm.live_until_date}
                onChange={(e) =>
                  setLivePeriodForm({
                    ...livePeriodForm,
                    live_until_date: e.target.value,
                  })
                }
                InputLabelProps={{shrink: true}}
              />
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onSave} variant='contained'>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

LivePeriodDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  livePeriodForm: PropTypes.shape({
    live_period_type: PropTypes.string,
    live_duration_days: PropTypes.number,
    live_until_date: PropTypes.string,
  }).isRequired,
  setLivePeriodForm: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default LivePeriodDialog;
